export default __webpack_public_path__ + "static/media/simplicity.57f39257.png";